import { Component, Input , Output, EventEmitter} from '@angular/core';


/**
 * Helper box list item component, used to display an item in a list with an optional close button, main text, action text and right text.
 * Icon is optional and can be used to display an action icon on the right side of the main text.
 * icon available actions are now: "download".
 */
@Component({
    selector: 'core-helpers-box-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss']
})
export class HelperBoxListItemComponent {

    @Input() close: boolean = false;
    @Output() onCloseClick = new EventEmitter<any>();

    @Input() mainText: string;
    @Output() onMainTextClick = new EventEmitter<any>();

    @Input() actionText: string = "";
    @Output() onActionTextClick = new EventEmitter<any>();

    @Input() rightText: string = "";
    @Output() onRightTextClick = new EventEmitter<any>();

    @Input() actionIcon: string = "";
    @Output() onIconClick = new EventEmitter<any>();
        
}
